module.exports = __webpack_public_path__ + "static/img/IMG_20170901_193239.79d24190.jpg";